import React from "react";
import cns from "classnames";
import locale from "@bonliva-crm/locale";
import { useObserver } from "mobx-react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Grid
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { Checkbox, Select } from "@components/formx";
import { TeacherStore, Specialization } from "./TeacherStore";
import { ExpDelete, OutlinedInput } from "../Common";

type TeacherSpecializationProp = {
  profAoEItem: string;
  specializations: Specialization[];
};

type Props = {
  store: TeacherStore;
};

export function TeacherExpertise(props: Props) {
  const teacherStore = props.store;
  const profItem = `professions.${teacherStore.storeIndex}`;
  const classes = useStyles({});

  return useObserver(() => (
    <>
      <Paper className={classes.paperTable}>
        <ExpDelete onDeleteClick={teacherStore.deleteExpertise} />

        {teacherStore.areasOfExpertise.map((item, i) => {
          const itemName = `${profItem}.areasOfExpertise.${i}`;
          return (
            <div key={itemName}>
              <Grid
                container
                className={cns(
                  classes.aoeTitleRow,
                  item.selected && classes.aoeTitleRowSelected
                )}
              >
                <Grid item xs={12} md={4} xl={3}>
                  <Checkbox
                    name={`${itemName}.selected`}
                    label={item.name}
                    FormControlLabelProps={{
                      classes: { label: classes.aoeLabel }
                    }}
                  />
                </Grid>
              </Grid>

              {item.selected && item.specializations.length !== 0 && (
                <TeacherSpecialization
                  specializations={item.specializations}
                  profAoEItem={itemName}
                />
              )}
            </div>
          );
        })}
      </Paper>

      <Paper style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <Select
              label={locale.SchoolPlatforms}
              name={`${profItem}.schoolPlatforms`}
              multi
              options={teacherStore.schoolPlatforms.map((x) => ({
                label: x,
                value: x
              }))}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Select
              label={locale.DigitalCompetence}
              name={`${profItem}.digitalCompetence`}
              multi
              options={teacherStore.digitalCompetence.map((x) => ({
                label: x,
                value: x
              }))}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  ));
}

function TeacherSpecialization(props: TeacherSpecializationProp) {
  const { specializations, profAoEItem } = props;

  return useObserver(() => (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell align="left" style={{ width: "25%" }}>
            {locale.Specializations}
          </TableCell>
          <TableCell align="center" style={{ width: 64 }}>
            {locale.Qualified}
          </TableCell>
          <TableCell align="center" style={{ width: 64 }}>
            {locale["Interested in"]}
          </TableCell>
          <TableCell align="center">{locale.ExperienceYearFrom}</TableCell>
          <TableCell style={{ width: "100%" }} />
        </TableRow>
      </TableHead>

      <TableBody>
        {specializations.map((row, i) => {
          const itemName = `${profAoEItem}.specializations.${i}`;
          return (
            <TableRow key={itemName}>
              <TableCell>{row.name}</TableCell>
              <TableCell align="center">
                <Checkbox name={`${itemName}.qualified`} />
              </TableCell>
              <TableCell align="center">
                <Checkbox name={`${itemName}.interestedIn`} />
              </TableCell>
              <TableCell align="center">
                <OutlinedInput name={`${itemName}.experience`} label={locale.YYYYorX} />
              </TableCell>
              <TableCell />
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  ));
}

const useStyles = makeStyles((theme: ThemeType) => ({
  paperTable: {
    position: "relative"
  },

  aoeTitleRow: {
    display: "flex",
    alignItems: "center",
    padding: 16,
    borderBottom: `1px solid #eee`
  },

  aoeTitleRowSelected: {
    background: "aliceblue"
  },

  aoeLabel: {
    fontSize: "1.1rem",
    fontWeight: 500
  },

  aoeText: {
    paddingLeft: theme.spacing(4)
  },

  systems: {
    ...theme.mixins.childrenMarginBottom(8)
  }
}));
